<!-- Placeholder geometry for the nearest drop-off card while locator search is pending. -->
<div class="nearest-drop-off-skeleton" aria-hidden="true" data-testid="nearest-drop-off-skeleton">
  <app-skeleton-block width="220" height="22" />
  <app-skeleton-block width="160" height="11" tone="secondary" />
  <app-skeleton-block width="280" height="18" />
  <app-skeleton-block width="70%" height="11" tone="secondary" />
  <app-skeleton-block width="55%" height="11" tone="secondary" />
  <div class="nearest-drop-off-skeleton__services">
    <app-skeleton-block width="120" height="11" tone="secondary" />
    <app-skeleton-block width="90" height="11" tone="secondary" />
    <app-skeleton-block width="100" height="11" tone="secondary" />
  </div>
</div>
